module.exports = __webpack_public_path__ + "teqbahn-assets/media/project_2.9440c570.png";